<router-outlet />
<p-toast key="portal" position="bottom-center" />
<p-confirm-dialog [style]="{ width: '90vw', maxWidth: '36rem' }" />
